import React, { useState, createContext, useContext } from 'react'

const initScannerContextPropsState = {
  pass: undefined,
  setPass: () => {},
  openModal: false,
  setOpenModal: () => {},
}

const ScannerContext = createContext(initScannerContextPropsState)

const useScanner = () => {
  return useContext(ScannerContext)
}

const ScannerProvider = ({ children }) => {
  const [pass, setPass] = useState(undefined)
  const [openModal, setOpenModal] = useState(false)

  return (
    <ScannerContext.Provider value={{ pass, setPass, openModal, setOpenModal }}>
      {children}
    </ScannerContext.Provider>
  )
}

export { ScannerProvider, useScanner }
